import { H1Span } from "@constellation-academy/epic-ui";
import React from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { messageDispatches_MessageDispatchesQuery } from "@relay/messageDispatches_MessageDispatchesQuery.graphql";
import { MessageDispatchContextProvider } from "./message-dispatches.context";
import { QUERY } from "./message-dispatches.graphql";
import { BaseScreen } from "../../components/base-screen";
import { MessageDispatchesTable } from "../message-dispatch-edit/parts/message-dispatches-table";

export const MessageDispatchesScreen = () => {
	const { t } = useTranslation("common");
	const data = useLazyLoadQuery<messageDispatches_MessageDispatchesQuery>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	return (
		<MessageDispatchContextProvider>
			<BaseScreen>
				<H1Span>{t("messageDispatch.screenTitle")}</H1Span>
				<MessageDispatchesTable messageDispatchesFragmentRef={data} />
			</BaseScreen>
		</MessageDispatchContextProvider>
	);
};
